package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_09_01_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have just left the Traveler’s Doorstep, a famous shop in Malus. They head to the military barracks north of the palace for a meeting with Voth Gardul, Commander of the City Guard.  When they arrive, they find Voth Gardul, Sir Sorlon Dragstone (a high level officer in the Malusian Calvary), Sir Lorn Fogarth of the Peers, and an unfamiliar woman wearing blue robes. Both Gardul greets our heroes and introduces Sir Sorlon Dragstone, Sir Lorn Fogarth, as well as the newcomer, Lady Soren Aventary of the Peers. The meeting is top secret, and the conference room has been secured by an anti-scrying device. Our heroes are curious about some recent events and learn a few things.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The Green Dragon Sylus and Lalia appear to be aligned against the Dorvidian Empire. (Potentially an enemy of my enemy situation)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The breach in the plane of existence is associated with a demonic entity.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The demonic traffic from the Abyss through the breach into Veldekar is less than anticipated — potentially due to the conflict between Hell and the Abyss.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The Green Dragon Sylus is an agent of Lalia. He is from Veldekar, so he can operate in Veldekar without risk of being banished (unlike Lalia).")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The Roving Peers gave Sylus a deadline of the 37th of Newgrowth to leave — our heroes had been concerned that the Malusians weren’t taking the threat of a dragon seriously.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The Malusian army is investigating smuggling in the Darkway. They believe the dead dwarves our heroes discovered on the 28th of Newgrowth (6/2/23) were part of a smuggling ring.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("There has been an uptick of thievery and other crimes in the city.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Giants and Goblinoids are coming from the hills, supposedly displaced by Dragon-kind.  But these Goblins are not organized like the ones our heroes fought.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("There is a piece of the Shield of Concar in a cavern north of Zedj.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lady Aventary can teleport our heroes to Rognirak.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Zedj is normally a quiet farming and logging community but is currently hosting a large contingent of the Malusian army. They patrol the roads due to the Giant/Goblinoid threat.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes make plans for the next couple of days. Tomorrow after lunch, they agree to be interviewed about an investigation. The day after tomorrow, they plan to meet after breakfast to begin the travel toward Zedj. When our heroes leave the room, they notice the effect of the dampening field. Lady Aventary agrees to train Dirk in dampening fields.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Back at the Gleaming Horde, Goram explains to the other heroes that he thinks he might be related to Voth Gardul. Goram never met his father, so he is interested to learn more.  Falorn spots an acquaintance Rory Delathos, a wood elf who was a scout for an organization that Falorn used to work for. Falorn follows Rory out of the Gleaming Horde, but Rory jumps a fence, and Falorn loses him and gives up.")
    }
}
